if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Add order type from session storage
        const orderType = sessionStorage.getItem('order_type');
        if (orderType) {
          formData.append('attributes[order_type]', orderType);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    this.checkAndUpdateOrderType();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              this.checkAndUpdateOrderType();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async checkAndUpdateOrderType() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          // Check if any item has fw26 tag
          const hasFW26 = cart.items.some(item => 
            item.product_tags && item.product_tags.includes('fw26')
          );
          
          // If FW26 products exist and order_type is not already preorder, update it
          if (hasFW26 && cart.attributes.order_type !== 'preorder') {
            sessionStorage.setItem('order_type', 'preorder');
            
            // Update cart attributes
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { order_type: 'preorder' }
              })
            });
            
            // Refresh cart display
            if (this.cart) {
              const updatedCart = await fetch('/cart.js').then(r => r.json());
              this.cart.renderContents(updatedCart);
            }
          }
        } catch (error) {
          console.error('Error checking cart for FW26 products:', error);
        }
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      async checkAndUpdateOrderType() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          // Check if any item has fw26 tag
          const hasFW26 = cart.items.some(item => 
            item.product_tags && item.product_tags.includes('fw26')
          );
          
          // If FW26 products exist and order_type is not already preorder, update it
          if (hasFW26 && cart.attributes.order_type !== 'preorder') {
            sessionStorage.setItem('order_type', 'preorder');
            
            // Update cart attributes
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { order_type: 'preorder' }
              })
            });
            
            // Refresh cart display
            if (this.cart) {
              const updatedCart = await fetch('/cart.js').then(r => r.json());
              this.cart.renderContents(updatedCart);
            }
          }
        } catch (error) {
          console.error('Error checking cart for FW26 products:', error);
        }
      }
    }
  );
}
